import { createSlice } from '@reduxjs/toolkit'

import { followReplyAdapter } from 'apps/followReply/adapter'
import { createFlowReducer } from 'apps/followReply/store/actions/createFlow'
import { loadFlowReducer } from 'apps/followReply/store/actions/loadFlow'
import { removeFlowReducer } from 'apps/followReply/store/actions/removeFlow'
import { setFlowReducer } from 'apps/followReply/store/actions/setFlow'
import { toggleFlowReducer } from 'apps/followReply/store/actions/toggleFlow'
import { updateDelayReducer } from 'apps/followReply/store/actions/updateDelay'
import {
  getChannelState,
  getFollowReplyChannelDefaultState,
  NAMESPACE,
} from 'apps/followReply/store/constants'
import { FLOW_TRIGGER_UPDATED } from 'common/flow/constants/flowReduxActionTypes'
import { FollowReply } from 'shared/api/common/schemas/flow'
import { accountNotificationsListener } from 'utils/services/notificationsService'
import { INotificationServiceData } from 'utils/services/notificationsService/notificationsServiceTypes'

import { FOLLOW_REPLY_CHANNEL } from '../constants'
import { FollowReplyState } from '../interfaces'

/**
 * Now backend is working only with IG channel and don't send to us channel in response,
 * and we don't need to send channel to them, so we're using constant channel to work with the store
 */
const initialState: FollowReplyState = {
  [FOLLOW_REPLY_CHANNEL]: getFollowReplyChannelDefaultState(),
}

const { actions, reducer } = createSlice({
  name: NAMESPACE,
  initialState: initialState,
  reducers: {
    updateFlow: (state, action) => {
      const data = action.payload
      state[FOLLOW_REPLY_CHANNEL] = getChannelState(data)
    },
  },
  extraReducers: (builder) => {
    loadFlowReducer(builder)
    createFlowReducer(builder)
    removeFlowReducer(builder)
    setFlowReducer(builder)
    toggleFlowReducer(builder)
    updateDelayReducer(builder)
  },
})

export const followReplyReducer = reducer

accountNotificationsListener.on(
  'follow_reply_updated',
  (data: INotificationServiceData<FollowReply>, dispatch) => {
    dispatch(actions.updateFlow(data.model))

    dispatch({
      type: FLOW_TRIGGER_UPDATED,
      entity: 'followReply',
      item: followReplyAdapter(data.model),
    })
  },
)
